import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
// Add your imports here
import Login from "pages/login";
import Signup from "pages/signup";
import OnboardingWizard from "components/onboarding/OnboardingWizard";
import Dashboard from "pages/dashboard";

import CRMPage from "pages/crm";
import ClientsPage from "pages/clients";
import CampaignsPage from "pages/campaigns";
import ReviewSubmission from "pages/review-submission";
import ReviewManagement from "pages/reviews";
import InstantRequest from "pages/instant-request";

import Settings from "pages/settings";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/review-submission" element={<ReviewSubmission />} />
        
        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/onboarding" element={<ProtectedRoute><OnboardingWizard /></ProtectedRoute>} />
        
        {/* Customer Hub - Protected */}
        <Route path="/customer-management" element={<ProtectedRoute><Navigate to="/crm" replace /></ProtectedRoute>} />
        <Route path="/crm" element={<ProtectedRoute><CRMPage /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
        <Route path="/campaigns" element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>} />
        <Route path="/reviews" element={<ProtectedRoute><ReviewManagement /></ProtectedRoute>} />
        <Route path="/instant-request" element={<ProtectedRoute><InstantRequest /></ProtectedRoute>} />
        
        {/* Legacy redirects - Protected */}
        <Route path="/properties" element={<ProtectedRoute><Navigate to="/clients" replace /></ProtectedRoute>} />
        <Route path="/services" element={<ProtectedRoute><Navigate to="/settings" replace /></ProtectedRoute>} />
        <Route path="/reports/financial" element={<ProtectedRoute><Navigate to="/dashboard" replace /></ProtectedRoute>} />
        <Route path="/reports/customers" element={<ProtectedRoute><Navigate to="/dashboard" replace /></ProtectedRoute>} />
        <Route path="/settings/users" element={<ProtectedRoute><Navigate to="/settings" replace /></ProtectedRoute>} />
        
        {/* System - Protected */}
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        
        {/* Catch all - Public */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;